export default __webpack_public_path__ + "img/eSEGsTkv.7c1a498a.svg";